module.exports = __webpack_public_path__ + "static/media/unemployment.13e1a247.svg";